export default "__VITE_ASSET__drrVDnZO__"